// This file is automatically generated from Rails routes.
// DO NOT modify it manually.
// To regenerate, run: bin/rake gitlab:js:routes

import { __jsr } from '~/lib/utils/path_helpers/core';
import { resolveOrganizationScope } from '~/lib/utils/path_helpers/utils';


/**
 * Generates the Rails route:
 *
 * - href: `/unsubscribes/:email(.:format)`
 * - Path helper: `unsubscribe_path`
 * - URL helper: `unsubscribe_url`
 * - controller#action: `users/unsubscribes#show`
 *
 * @param {any} email
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const unsubscribePath = /*#__PURE__*/ (...args) => {
  const _organizationUnsubscribePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"email":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"unsubscribes"],[2,[7,"/"],[2,[3,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _unsubscribePath = /*#__PURE__*/ __jsr.r({"email":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"unsubscribes"],[2,[7,"/"],[2,[3,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUnsubscribePath(organizationPath, ...routeArgs);
  }

  return _unsubscribePath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/auth/geo/sign_in(.:format)`
 * - Path helper: `users_auth_geo_sign_in_path`
 * - URL helper: `users_auth_geo_sign_in_url`
 * - controller#action: `sessions#new`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const usersAuthGeoSignInPath = /*#__PURE__*/ (...args) => {
  const _organizationUsersAuthGeoSignInPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"geo"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _usersAuthGeoSignInPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"geo"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUsersAuthGeoSignInPath(organizationPath, ...routeArgs);
  }

  return _usersAuthGeoSignInPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/auth/geo/sign_out(.:format)`
 * - Path helper: `users_auth_geo_sign_out_path`
 * - URL helper: `users_auth_geo_sign_out_url`
 * - controller#action: `sessions#destroy`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const usersAuthGeoSignOutPath = /*#__PURE__*/ (...args) => {
  const _organizationUsersAuthGeoSignOutPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"geo"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _usersAuthGeoSignOutPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"geo"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUsersAuthGeoSignOutPath(organizationPath, ...routeArgs);
  }

  return _usersAuthGeoSignOutPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/almost_there(.:format)`
 * - Path helper: `users_almost_there_path`
 * - URL helper: `users_almost_there_url`
 * - controller#action: `confirmations#almost_there`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const usersAlmostTherePath = /*#__PURE__*/ (...args) => {
  const _organizationUsersAlmostTherePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"almost_there"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _usersAlmostTherePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"almost_there"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUsersAlmostTherePath(organizationPath, ...routeArgs);
  }

  return _usersAlmostTherePath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/resend_verification_code(.:format)`
 * - Path helper: `users_resend_verification_code_path`
 * - URL helper: `users_resend_verification_code_url`
 * - controller#action: `sessions#resend_verification_code`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const usersResendVerificationCodePath = /*#__PURE__*/ (...args) => {
  const _organizationUsersResendVerificationCodePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"resend_verification_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _usersResendVerificationCodePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"resend_verification_code"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUsersResendVerificationCodePath(organizationPath, ...routeArgs);
  }

  return _usersResendVerificationCodePath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/successful_verification(.:format)`
 * - Path helper: `users_successful_verification_path`
 * - URL helper: `users_successful_verification_url`
 * - controller#action: `sessions#successful_verification`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const usersSuccessfulVerificationPath = /*#__PURE__*/ (...args) => {
  const _organizationUsersSuccessfulVerificationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"successful_verification"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _usersSuccessfulVerificationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"successful_verification"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUsersSuccessfulVerificationPath(organizationPath, ...routeArgs);
  }

  return _usersSuccessfulVerificationPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/skip_verification_for_now(.:format)`
 * - Path helper: `users_skip_verification_for_now_path`
 * - URL helper: `users_skip_verification_for_now_url`
 * - controller#action: `sessions#skip_verification_for_now`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const usersSkipVerificationForNowPath = /*#__PURE__*/ (...args) => {
  const _organizationUsersSkipVerificationForNowPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"skip_verification_for_now"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _usersSkipVerificationForNowPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"skip_verification_for_now"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUsersSkipVerificationForNowPath(organizationPath, ...routeArgs);
  }

  return _usersSkipVerificationForNowPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/skip_verification_confirmation(.:format)`
 * - Path helper: `users_skip_verification_confirmation_path`
 * - URL helper: `users_skip_verification_confirmation_url`
 * - controller#action: `sessions#skip_verification_confirmation`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const usersSkipVerificationConfirmationPath = /*#__PURE__*/ (...args) => {
  const _organizationUsersSkipVerificationConfirmationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"skip_verification_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _usersSkipVerificationConfirmationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"skip_verification_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUsersSkipVerificationConfirmationPath(organizationPath, ...routeArgs);
  }

  return _usersSkipVerificationConfirmationPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/fallback_to_email_otp(.:format)`
 * - Path helper: `users_fallback_to_email_otp_path`
 * - URL helper: `users_fallback_to_email_otp_url`
 * - controller#action: `sessions#fallback_to_email_otp`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const usersFallbackToEmailOtpPath = /*#__PURE__*/ (...args) => {
  const _organizationUsersFallbackToEmailOtpPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"fallback_to_email_otp"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _usersFallbackToEmailOtpPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"fallback_to_email_otp"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUsersFallbackToEmailOtpPath(organizationPath, ...routeArgs);
  }

  return _usersFallbackToEmailOtpPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/passkeys/sign_in(.:format)`
 * - Path helper: `users_passkeys_sign_in_path`
 * - URL helper: `users_passkeys_sign_in_url`
 * - controller#action: `sessions#new_passkey`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const usersPasskeysSignInPath = /*#__PURE__*/ (...args) => {
  const _organizationUsersPasskeysSignInPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"passkeys"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _usersPasskeysSignInPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"passkeys"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUsersPasskeysSignInPath(organizationPath, ...routeArgs);
  }

  return _usersPasskeysSignInPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/sign_in_path(.:format)`
 * - Path helper: `users_sign_in_path_path`
 * - URL helper: `users_sign_in_path_url`
 * - controller#action: `sessions#sign_in_path`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const usersSignInPathPath = /*#__PURE__*/ (...args) => {
  const _organizationUsersSignInPathPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in_path"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _usersSignInPathPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in_path"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUsersSignInPathPath(organizationPath, ...routeArgs);
  }

  return _usersSignInPathPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/auth(.:format)`
 * - Path helper: `users_auth_path`
 * - URL helper: `users_auth_url`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const usersAuthPath = /*#__PURE__*/ (...args) => {
  const _organizationUsersAuthPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _usersAuthPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUsersAuthPath(organizationPath, ...routeArgs);
  }

  return _usersAuthPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/users/terms/:id/accept(.:format)`
 * - Path helper: `accept_term_path`
 * - URL helper: `accept_term_url`
 * - controller#action: `users/terms#accept`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const acceptTermPath = /*#__PURE__*/ (...args) => {
  const _acceptOrganizationTermPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"terms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _acceptTermPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"terms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _acceptOrganizationTermPath(organizationPath, ...routeArgs);
  }

  return _acceptTermPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/users/terms/:id/decline(.:format)`
 * - Path helper: `decline_term_path`
 * - URL helper: `decline_term_url`
 * - controller#action: `users/terms#decline`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const declineTermPath = /*#__PURE__*/ (...args) => {
  const _declineOrganizationTermPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"terms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"decline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _declineTermPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"terms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"decline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _declineOrganizationTermPath(organizationPath, ...routeArgs);
  }

  return _declineTermPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/users/terms(.:format)`
 * - Path helper: `terms_path`
 * - URL helper: `terms_url`
 * - controller#action: `users/terms#index`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const termsPath = /*#__PURE__*/ (...args) => {
  const _organizationTermsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"terms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _termsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"terms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationTermsPath(organizationPath, ...routeArgs);
  }

  return _termsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/users/callouts(.:format)`
 * - Path helper: `callouts_path`
 * - URL helper: `callouts_url`
 * - controller#action: `users/callouts#create`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const calloutsPath = /*#__PURE__*/ (...args) => {
  const _organizationCalloutsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"callouts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _calloutsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"callouts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationCalloutsPath(organizationPath, ...routeArgs);
  }

  return _calloutsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/users/group_callouts(.:format)`
 * - Path helper: `group_callouts_path`
 * - URL helper: `group_callouts_url`
 * - controller#action: `users/group_callouts#create`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const groupCalloutsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupCalloutsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"group_callouts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _groupCalloutsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"group_callouts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationGroupCalloutsPath(organizationPath, ...routeArgs);
  }

  return _groupCalloutsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/users/project_callouts(.:format)`
 * - Path helper: `project_callouts_path`
 * - URL helper: `project_callouts_url`
 * - controller#action: `users/project_callouts#create`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectCalloutsPath = /*#__PURE__*/ (...args) => {
  const _organizationProjectCalloutsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"project_callouts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _projectCalloutsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"project_callouts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationProjectCalloutsPath(organizationPath, ...routeArgs);
  }

  return _projectCalloutsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/users/broadcast_message_dismissals(.:format)`
 * - Path helper: `broadcast_message_dismissals_path`
 * - URL helper: `broadcast_message_dismissals_url`
 * - controller#action: `users/broadcast_message_dismissals#create`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const broadcastMessageDismissalsPath = /*#__PURE__*/ (...args) => {
  const _organizationBroadcastMessageDismissalsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"broadcast_message_dismissals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _broadcastMessageDismissalsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"broadcast_message_dismissals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationBroadcastMessageDismissalsPath(organizationPath, ...routeArgs);
  }

  return _broadcastMessageDismissalsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/users/pins(.:format)`
 * - Path helper: `pins_path`
 * - URL helper: `pins_url`
 * - controller#action: `users/pins#update`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const pinsPath = /*#__PURE__*/ (...args) => {
  const _organizationPinsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"pins"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _pinsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"pins"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationPinsPath(organizationPath, ...routeArgs);
  }

  return _pinsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/:username/calendar(.:format)`
 * - Path helper: `user_calendar_path`
 * - URL helper: `user_calendar_url`
 * - controller#action: `users#calendar`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userCalendarPath = /*#__PURE__*/ (...args) => {
  const _organizationUserCalendarPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"calendar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userCalendarPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"calendar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserCalendarPath(organizationPath, ...routeArgs);
  }

  return _userCalendarPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/:username/calendar_activities(.:format)`
 * - Path helper: `user_calendar_activities_path`
 * - URL helper: `user_calendar_activities_url`
 * - controller#action: `users#calendar_activities`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userCalendarActivitiesPath = /*#__PURE__*/ (...args) => {
  const _organizationUserCalendarActivitiesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"calendar_activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userCalendarActivitiesPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"calendar_activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserCalendarActivitiesPath(organizationPath, ...routeArgs);
  }

  return _userCalendarActivitiesPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/:username/groups(.:format)`
 * - Path helper: `user_groups_path`
 * - URL helper: `user_groups_url`
 * - controller#action: `users#groups`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userGroupsPath = /*#__PURE__*/ (...args) => {
  const _organizationUserGroupsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userGroupsPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserGroupsPath(organizationPath, ...routeArgs);
  }

  return _userGroupsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/:username/projects(.:format)`
 * - Path helper: `user_projects_path`
 * - URL helper: `user_projects_url`
 * - controller#action: `users#projects`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userProjectsPath = /*#__PURE__*/ (...args) => {
  const _organizationUserProjectsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userProjectsPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserProjectsPath(organizationPath, ...routeArgs);
  }

  return _userProjectsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/:username/contributed(.:format)`
 * - Path helper: `user_contributed_projects_path`
 * - URL helper: `user_contributed_projects_url`
 * - controller#action: `users#contributed`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userContributedProjectsPath = /*#__PURE__*/ (...args) => {
  const _organizationUserContributedProjectsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"contributed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userContributedProjectsPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"contributed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserContributedProjectsPath(organizationPath, ...routeArgs);
  }

  return _userContributedProjectsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/:username/starred(.:format)`
 * - Path helper: `user_starred_projects_path`
 * - URL helper: `user_starred_projects_url`
 * - controller#action: `users#starred`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userStarredProjectsPath = /*#__PURE__*/ (...args) => {
  const _organizationUserStarredProjectsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"starred"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userStarredProjectsPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"starred"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserStarredProjectsPath(organizationPath, ...routeArgs);
  }

  return _userStarredProjectsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/:username/projects/contributed(.:format)`
 * - Path helper: `user_projects_contributed_path`
 * - URL helper: `user_projects_contributed_url`
 * - controller#action: `users#projects`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userProjectsContributedPath = /*#__PURE__*/ (...args) => {
  const _organizationUserProjectsContributedPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"contributed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _userProjectsContributedPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"contributed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserProjectsContributedPath(organizationPath, ...routeArgs);
  }

  return _userProjectsContributedPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/:username/projects/starred(.:format)`
 * - Path helper: `user_projects_starred_path`
 * - URL helper: `user_projects_starred_url`
 * - controller#action: `users#projects`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userProjectsStarredPath = /*#__PURE__*/ (...args) => {
  const _organizationUserProjectsStarredPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starred"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _userProjectsStarredPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starred"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserProjectsStarredPath(organizationPath, ...routeArgs);
  }

  return _userProjectsStarredPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/:username/snippets(.:format)`
 * - Path helper: `user_snippets_path`
 * - URL helper: `user_snippets_url`
 * - controller#action: `users#snippets`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userSnippetsPath = /*#__PURE__*/ (...args) => {
  const _organizationUserSnippetsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"snippets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userSnippetsPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"snippets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserSnippetsPath(organizationPath, ...routeArgs);
  }

  return _userSnippetsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/:username/followers(.:format)`
 * - Path helper: `user_followers_path`
 * - URL helper: `user_followers_url`
 * - controller#action: `users#followers`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userFollowersPath = /*#__PURE__*/ (...args) => {
  const _organizationUserFollowersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"followers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userFollowersPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"followers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserFollowersPath(organizationPath, ...routeArgs);
  }

  return _userFollowersPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/:username/following(.:format)`
 * - Path helper: `user_following_path`
 * - URL helper: `user_following_url`
 * - controller#action: `users#following`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userFollowingPath = /*#__PURE__*/ (...args) => {
  const _organizationUserFollowingPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"following"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userFollowingPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"following"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserFollowingPath(organizationPath, ...routeArgs);
  }

  return _userFollowingPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/:username/exists(.:format)`
 * - Path helper: `user_exists_path`
 * - URL helper: `user_exists_url`
 * - controller#action: `users#exists`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userExistsPath = /*#__PURE__*/ (...args) => {
  const _organizationUserExistsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"exists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userExistsPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"exists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserExistsPath(organizationPath, ...routeArgs);
  }

  return _userExistsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/:username/activity(.:format)`
 * - Path helper: `user_activity_path`
 * - URL helper: `user_activity_url`
 * - controller#action: `users#activity`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userActivityPath = /*#__PURE__*/ (...args) => {
  const _organizationUserActivityPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userActivityPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserActivityPath(organizationPath, ...routeArgs);
  }

  return _userActivityPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/:username/follow(.:format)`
 * - Path helper: `user_follow_path`
 * - URL helper: `user_follow_url`
 * - controller#action: `users#follow`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userFollowPath = /*#__PURE__*/ (...args) => {
  const _organizationUserFollowPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"follow"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userFollowPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"follow"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserFollowPath(organizationPath, ...routeArgs);
  }

  return _userFollowPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/:username/unfollow(.:format)`
 * - Path helper: `user_unfollow_path`
 * - URL helper: `user_unfollow_url`
 * - controller#action: `users#unfollow`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userUnfollowPath = /*#__PURE__*/ (...args) => {
  const _organizationUserUnfollowPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"unfollow"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userUnfollowPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"unfollow"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserUnfollowPath(organizationPath, ...routeArgs);
  }

  return _userUnfollowPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:username.gpg(.:format)`
 * - Path helper: `user_gpg_keys_path`
 * - URL helper: `user_gpg_keys_url`
 * - controller#action: `users#gpg_keys`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userGpgKeysPath = /*#__PURE__*/ (...args) => {
  const _organizationUserGpgKeysPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[3,"username"],[2,[8,"."],[2,[6,"gpg"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _userGpgKeysPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[8,"."],[2,[6,"gpg"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserGpgKeysPath(organizationPath, ...routeArgs);
  }

  return _userGpgKeysPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:username(.:format)`
 * - Path helper: `user_path`
 * - URL helper: `user_url`
 * - controller#action: `users#show`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userPath = /*#__PURE__*/ (...args) => {
  const _organizationUserPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[3,"username"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);
  const _userPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[1,[2,[8,"."],[3,"format"]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserPath(organizationPath, ...routeArgs);
  }

  return _userPath(...routeArgs);
};

